<template>
    <div v-if="display" :class="`filter-cont ${showInput ? 'filter-cont-active' : ''}`" :style="styles">
        <div class="filter-area">
            <div class="filter-label">{{label}}</div>

            <form class="filter-input" @submit.prevent="handleSubmit">
              <v-autocomplete
                v-if="isList"
                v-model="filterValue"
                :label="placeholder"
                :items="list"
                solo
                id="filter-field-select-id"
                class="filter-field-select-class"
                item-text="info"
                item-value="id"
              ></v-autocomplete>

                <date-picker
                  v-else-if="isDate"
                  lang="en"
                  :width="width || 195"
                  :append-to-body="true"
                  :format="timeFormat || 'MM/DD/YYYY'"
                  :type="datepickerType || 'date'"
                  :time-picker-options="timePickerOptions"
                  :shortcuts="false"
                  :clearable="false"
                  :placeholder="placeholder"
                  :name="name"
                  ref="textInput"
                  input-class="filter-input"
                  :not-after="new Date()"
                  range
                  confirm
                  v-model="filterValue"
                >
                  <template slot="calendar-icon">
                    <div style="display: none"></div>
                  </template>
                </date-picker>

                <input
                  v-else
                  type="text"
                  :name="name"
                  :placeholder="placeholder"
                  v-model="filterValue"
                  ref="textInput"
                  autofocus
                >
            </form>
        </div>
        <div class="filter-buttons">
          <button v-if="!showInput" class="filter-open" @click="showInput=true"></button>
          <v-btn
            v-if="!isList && !isDate && filterValue && (currentValue !== filterValue)"
            @click="handleSubmit();"
            class="filter-save-btn" depressed flat icon color="green"
          >
            <v-icon>done</v-icon>
          </v-btn>
          <v-btn
           v-else-if="showInput || (isDate && filterValue !== '')"
           @click="handleClose();"
           class="filter-close-btn" color="#fff" small
           depressed flat icon
          >
            <v-icon >clear</v-icon>
          </v-btn>
        </div>
    </div>
    <span v-else>{{label}}</span>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'filterField',
  components: { DatePicker },
  props: {
    display: Boolean,
    label: { type: String, required: true },
    styles: String,
    optionStyles: String,
    id: String, // is not used?
    name: { type: String, required: true },
    placeholder: String,
    type: String, // list||select, date
    datepickerType: String,
    timeFormat: String,
    timePickerOptions: Object,
    width: String,
    list: Array, // { _id: '', info: '' }
  },
  data () {
    const data = {
      isList: this.type === 'list' || this.type === 'select',
      isDate: this.type === 'date',
      filterValue: (this.$route.query || {})[this.name] || '', // value from query
      currentValue: (this.$route.query || {})[this.name] || '',
      searchAutocomplete: '',
    }

    if (this.type === 'select') {
      const val = (this.$route.query || {})[this.name] || '';
      if (!!val && +val == val) {
        data.showInput = true;
        data.filterValue = +val
      }
      else data.filterValue = val;
    }

    if (this.name === 'date_range' && this.$route.query && this.$route.query.start_date && this.$route.query.end_date) {
      data.filterValue = [new Date(this.$route.query.start_date), new Date(this.$route.query.end_date)]
    }

    data.showInput = data.showInput || data.filterValue;

    return data
  },
  methods: {
    handleSubmit () {
      // make query
      const query = _.clone(this.$route.query) || {}

      if (this.filterValue && this.name === 'date_range') {
        if (this.datepickerType === 'datetime') {
          query.start_date = moment(this.filterValue[0]).format(this.timeFormat)
          query.end_date = moment(this.filterValue[1]).format(this.timeFormat)
        } else {
          query.start_date = moment(this.filterValue[0]).startOf('day').format('l')
          query.end_date = moment(this.filterValue[1]).endOf('day').format('l')
        }
      } else if (this.name === 'date_range' && !this.filterValue && query.start_date && query.end_date) {
        query.start_date = ''
        query.end_date = ''
      } else {
        query[this.name] = this.filterValue;
        this.currentValue = this.filterValue;
      }

      // delete empty filters
      _.mapKeys(query, (i, key) => {
        if (!_.isNumber(query[key]) && _.isEmpty(query[key])) delete query[key]
      })

      this.$router.replace({ query })
    },
    handleClose() {
      this.filterValue = '';
      this.showInput = false;
      this.handleSubmit();
    }
  },
  watch: {
    filterValue: function (val, oldVal) {
      if (this.isList || this.isDate) this.handleSubmit()
    },
    showInput (newVal) {
      const { textInput } = this.$refs
      if (newVal && textInput) {
        setTimeout(() => textInput.focus(), 50)
      }
      this.$emit('show-input', newVal)
    }
  },
}
</script>
<style lang="css" scoped>
  .v-btn:hover:before,
  .v-btn:focus:before,
  .filter-close-btn:hover,
  .filter-save-btn:hover {
    background: unset;
  }

  .filter-area {
    width: 100%;
    margin: 3px 0 0 0;
  }

  .filter-area .filter-buttons {
    margin-left: 5px;
  }

  .filter-buttons .filter-save-btn {
    height: 28px;
  }

  .filter-field-select-class {
    height: 22px;
    padding: 0;
    margin: 0;
  }

  .filter-field-select-class >>> .v-input__control {
    min-height: 22px;
    max-height: 22px;
  }

  .filter-field-select-class >>> .v-input__control .v-input__slot {
    min-height: 22px;
    max-height: 22px;
    margin: 0;
    padding: 0 5px;
  }

  .filter-field-select-class >>> .v-input__control .v-input__slot .v-select__slot {
    width: 100%;
    max-height: 22px;
    height: 22px;
    min-height: 22px;
  }

  .filter-field-select-class >>> .v-input__control .v-input__slot .v-select__slot .v-select__selections {
    width: 100px;
    max-height: 22px;
  }

  .filter-field-select-class >>> .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection {
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0;
    width: 100%;
  }

  .filter-field-select-class >>> .v-input__control .v-input__slot .v-select__slot .v-input__append-inner,
  .filter-field-select-class  >>> .v-input__control .v-input__slot .v-select__slot .v-select__selections #filter-field-select-id {
    display: none;
  }
  @media screen and (max-width: 600px){
    .filter-field-select-class {
    width: 80px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/filterField.vue